import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isFaireDirectVariant } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { EmailInput } from "@faire/retailer-visitor-shared/components/AppSignUp/components/EmailInput";
import { SignUpCTA } from "@faire/retailer-visitor-shared/components/AppSignUp/components/SignUpCTA";
import { useFetchHCaptchaToken } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getSettingEnableHCaptchaForLoginData } from "@faire/retailer-visitor-shared/settings/getSettingEnableHCaptchaForLoginData";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Spacer } from "@faire/web--source/slate/spacing";
import { trackSignupModalSubmitEmailClickClick } from "@faire/web-api--source/events/signup/click/modalSubmitEmailClick";
import { observer } from "mobx-react";
import React from "react";
var AppSignUpFormBase = function(param) {
    var email = param.email, modalVariant = param.modalVariant, omitLabel = param.omitLabel, _handleSubmit = param.handleSubmit, setEmailValidationErrors = param.setEmailValidationErrors, markUserEntersEmail = param.markUserEntersEmail, onSignUp = param.onSignUp;
    var isBrandPreview = getIsBrandPreview();
    var _useSSOStore = useSSOStore(), resetSSO = _useSSOStore.reset;
    var isSSR = useIsSSR();
    var fetchHCaptchaToken = useFetchHCaptchaToken(getSettingEnableHCaptchaForLoginData()).fetchHCaptchaToken;
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e, queryParamsOverride) {
            return _ts_generator(this, function(_state) {
                trackSignupModalSubmitEmailClickClick();
                onSignUp === null || onSignUp === void 0 ? void 0 : onSignUp();
                // In the case where the user initially wanted to sign up with
                // SSO but changed their minds, we do not want to populate signup fields
                // with stale SSO data.
                resetSSO();
                return [
                    2,
                    fetchHCaptchaToken(true).then(function() {
                        return _handleSubmit(e, queryParamsOverride);
                    })
                ];
            });
        });
        return function handleSubmit(e, queryParamsOverride) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(EmailInput, {
                email: email,
                onContinue: handleSubmit,
                onBlur: setEmailValidationErrors,
                disabled: isBrandPreview,
                markUserEntersEmail: markUserEntersEmail,
                omitLabel: omitLabel
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(SignUpCTA, {
                handleSubmit: handleSubmit,
                disabled: isBrandPreview || isSSR,
                isFaireDirect: isFaireDirectVariant(modalVariant)
            })
        ]
    });
};
export var AppSignUpForm = observer(AppSignUpFormBase);
